import { ErrorMessage } from './ErrorMessage';
import { AppRoutes } from '../../Routes';

export const ContainerComponent = (props) => {
  const { hasError } = props;

  return <div className="wrapper">{hasError ? <ErrorMessage /> : <AppRoutes />}</div>;
};
